// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[dir='rtl'] .modal__back-button {\n  -webkit-transform: scaleX(-1);\n          transform: scaleX(-1);\n}\n", "",{"version":3,"sources":["webpack://./src/components/molecules/Modal/Modal.styles.css"],"names":[],"mappings":"AAAA;EACE,6BAAqB;UAArB,qBAAqB;AACvB","sourcesContent":["[dir='rtl'] .modal__back-button {\n  transform: scaleX(-1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
